var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BobProPage',{attrs:{"columns":_vm.columns,"table-config":_vm.tableConfig},on:{"refresh":_vm.onRefresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }